import React from 'react'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import useTitleHasTooltip from 'components/insightContent/Overview/DetailItems/hooks'
import { StyledTitle } from 'components/insightContent/Overview/DetailItems/index.css'

const TitleContainer = ({ children }: { children: React.ReactNode }) => {
  const theme = useDisplayTheme() as Theme
  const { displayTooltip, titleContentRef } = useTitleHasTooltip()

  return (
    <StyledTitle mode={theme} ref={titleContentRef}>
      <Tooltip mode={theme} content={<span>{children}</span>} enabled={displayTooltip}>
        <span>{children}</span>
      </Tooltip>
    </StyledTitle>
  )
}

export default TitleContainer
